import React from 'react'
import { ISocialPopoverProps } from './interface'

import { apiUrlNew } from 'app/config'
import './styles.scss'
import Facebook from 'app/components/SVGS/Facebook'
import Twitter from 'app/components/SVGS/Twitter'
import Linkedin from 'app/components/SVGS/Linkedin'
import { isMobile } from 'react-device-detect'

const bc = 'social-popover'

export const getHash = ({ activityId, identityId }) => {
  return btoa(JSON.stringify({ activityId, userId: identityId }))
}
const openWindow = (url, target, features) => window.open(url, target, features)

const SocialPopover: React.FC<ISocialPopoverProps> = ({ activityId, identityId, t, windowWidth }) => {
  const hash = getHash({ activityId, identityId })
  const handleOpenWindow = url => {
    return openWindow(url, '', `width=600,height=500,left=${windowWidth / 2 - 300},top=200`)
  }
  return (
    <div className={`${bc}__info-popover`}>
      <div className={`${bc}__social-buttons`}>
        <span
          className={`${bc}__social-buttons-icon`}
          style={{ marginTop: '30px' }}
          onClick={() =>
            handleOpenWindow(
              `https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2F${apiUrlNew}%2Fv1%2Fshare%3Fhash%3D${hash}&mobile%3D${isMobile}&social%3Dfacebook`
            )
          }
        >
          <Facebook className={`${bc}__icon`} />
          <span style={{ marginLeft: '18px' }}>Share on Facebook</span>
        </span>
        <span
          className={`${bc}__social-buttons-icon`}
          onClick={() =>
            handleOpenWindow(
              `https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2F${apiUrlNew}%2Fv1%2Fshare%3Fhash%3D${hash}&mobile%3D${isMobile}&social%3Dlinkedin`
            )
          }
        >
          <Linkedin className={`${bc}__icon`} />
          <span style={{ marginLeft: '14px' }}>Share on Linkedin</span>
        </span>
        <span
          className={`${bc}__social-buttons-icon`}
          onClick={() =>
            handleOpenWindow(
              `https://twitter.com/intent/tweet?text=Share+My+Activity&url=https%3A%2F%2F${apiUrlNew}%2Fv1%2Fshare%3Fhash%3D${hash}&mobile%3D${isMobile}&social%3Dtwitter`
            )
          }
        >
          <Twitter className={`${bc}__icon`} />
          <span style={{ marginLeft: '13px' }}>Share on Twitter</span>
        </span>
      </div>
    </div>
  )
}

export default SocialPopover
